import playback from './playback.js';
import '@dtvgo/utils';
import '@dtvgo/error';
import '../types.js';

function entitlement(backendAxiosInstance) {
  return {
    ...playback(backendAxiosInstance)
  };
}

export { entitlement as default };
//# sourceMappingURL=index.js.map
